<template>
  <div class="user_container">
    <div class="user-top">
      <div class="flex">
        <img class="img" :src="driverInfo.icon" alt="" />
        <!-- <div>
          <p class="car">负责车辆</p>
          <p class="carid">{{ driverCarInfo?.carBrand }}</p>
        </div>
        <div>
          <p class="car">容纳人数</p>
          <p>{{ driverCarInfo?.maxCapacity }}</p>
        </div> -->
        <div class="carList">
          <div class="car_label">
            <div>负责车辆</div>
            <div>容纳人数</div>
          </div>
          <div class="car_item" v-for="item in driverList" :key="item.id">
            <div>
              <!-- <p class="car">负责车辆</p> -->
              <p class="carid">{{ item?.carBrand }}</p>
            </div>
            <div class="carP">
              <!-- <p class="car">容纳人数</p> -->
              <p>{{ item?.maxCapacity }}</p>
            </div>
          </div>
        </div>
        <!-- <div v-if="driverList.length < 1">
          <p class="car">负责车辆</p>
          <p class="carid">{{ driverCarInfo?.carBrand }}</p>
        </div>
        <div v-if="driverList.length < 1">
          <p class="car">容纳人数</p>
          <p>{{ driverCarInfo?.maxCapacity }}</p>
        </div> -->
      </div>
      <div>
        <p class="car">{{ driverCarInfo?.driverName }}</p>
        <p>{{ driverInfo?.department }}</p>
      </div>
    </div>
    <div class="flex car-foot">
      <div
        class="car-foot-nav flex"
        :style="{ backgroundImage: `url(${item.img})` }"
        v-for="item in list"
        :key="item.name"
        @click="toUseCar(item)"
      >
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car.js";
import api from "@/apis";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      list: [
        {
          name: "待办行程",
          img: require("@/assets/car/driver.png"),
          path: "/car/driver/driverRoute",
          showNum: true,
        },
        {
          name: "出车明细",
          img: require("@/assets/car/driver1.png"),
          path: "/car/facility/useCarDetail",
        },
        {
          name: "我要用车",
          img: require("@/assets/car/facility3.png"),
          path: "/car/official/index",
        },
      ],
      driverInfo: {},
      driverCarInfo: {},
      toDoList: [],
      driverList: [],
      applyDeptName: "",
    };
  },
  created() {
    this.driverInfo = JSON.parse(localStorage.getItem("store")).userInfo;
  },
  mounted() {
    this.getDriverInfo();
    this.queryUserName();
  },
  methods: {
    // 获取司机信息
    getDriverInfo() {
      const driverCode = this.$store.state.userInfo.username;
      apis.queryDriverInfo({ driverCode: driverCode }).then((res) => {
        if (res.code === 200) {
          this.driverCarInfo = res.data;
          this.driverList = res.data;
        }
      });
    },
    // 根据工号获取姓名
    queryUserName() {
      api
        .queryByUsername({ username: this.$store.state.userInfo.username })
        .then((res) => {
          if (res.code == 200) {
            this.applyDeptName = res.data.department;
          }
        })
        .catch(() => {
          this.$toast.fail("请输入正确工号");
        });
    },
    // 点击跳转，跳转详情
    toUseCar(item) {
      if (item.path == "/car/facility/useCarDetail") {
        localStorage.setItem("userCode", this.$store.state.userInfo.username);
      }
      this.$router.push(item.path);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  min-height: 100vh;
  padding: 50px 30px 30px 30px;
  margin: auto;
  font-size: 32px;
  background-color: rgb(247 249 250);

  .user-top {
    background-color: #4ea27c;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: relative;
    padding: 30px;
    color: #fff;

    .img {
      width: 130px;
      position: relative;
      top: -60px;
      left: 10px;
      border-radius: 50%;
    }

    .car {
      font-size: 24px;
      margin-bottom: 10px;
      font-weight: 100;
    }
  }

  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .carList{
      display: flex;
      flex-wrap: wrap;
      width: 60%;
      .car_label{
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 15px;
        div{
          width: 50%;
          text-align: center;
        }
      }
      .car_item{
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 15px;
        div{
          // margin-right: 30px;
          text-align: center;
          width: 50%;
        }
        .carP{
          text-align: center;
        }
        // flex-wrap: wrap;
      }
    }
  }

  .car-foot-nav {
    //
    width: 47%;
    height: 180px;
    font-size: 29px;
    font-weight: bold;
    background: #fff;
    border-radius: 20px;
    margin: 30px 0 0 0;
    padding: 20px;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>
